import 'typeface-oswald';
import 'prismjs/themes/prism-tomorrow.css';

export const onRouteUpdate = () => {
  if (typeof window === "undefined") return

  const loadWidgets = () => {
    window.twttr?.widgets?.load()
  }

  // すでにwidgets.jsが読み込まれている場合
  if (window.twttr) {
    loadWidgets()
    return
  }

  // widgets.jsをまだ読み込んでいない場合は動的に挿入
  const script = document.createElement("script")
  script.src = "https://platform.twitter.com/widgets.js"
  script.async = true
  script.charset = "utf-8"
  script.onload = loadWidgets
  document.body.appendChild(script)
}